import { Component } from '@angular/core';
import { ohTransition } from './oh.transition';
// <oh-loader #loaderId></oh-loader>
// this.loader.show();
// this.loader.close();
// this.loader.showError("");
// this.ohService.getOH().getLoader().show();
@Component({
	selector: 'oh-loader',
	templateUrl: './oh.loader.html',
	animations: [ohTransition],
	styleUrls: ['./oh.loader.css']
})

export class Loader {

	ohCarg: any;

	constructor() {
		this.ohCarg = {};
		this.ohCarg.show = false;
		this.ohCarg.emailAdm = "servicedesk@inlandservices.com";
		this.ohCarg.number = "5116140050";
		this.ohCarg.annexed = "2251";
		this.ohCarg.title = "Inlandnet - Error de sistema";
	}

	public setAttributes(attributes: any) {
		Object.assign(this.ohCarg, attributes);
	}

	public show(call?: Function) {
		this.ohCarg.show = true;
		this.ohCarg.view = 'C';
		setTimeout(() => {
			if (call) {
				call();
			}
		}, 500);
	}

	public showError(message: string, call?: Function) {
		this.ohCarg.show = true;
		this.ohCarg.errorDetail = false;
		this.ohCarg.view = 'E';
		this.ohCarg.error = message;
		setTimeout(() => {
			if (call) {
				call();
			}
		}, 500);
	}

	public close(call?: Function) {
		this.ohCarg.show = false;
		this.ohCarg.view = '';
		setTimeout(() => {
			if (call) {
				call();
			}
		}, 500);
	}

	private closeModal($event) {
		$event.preventDefault();
		this.close();
	}

	private showDetail($event) {
		$event.preventDefault();
		this.ohCarg.errorDetail = true;
	}

	private getBodyError(texto) {
		var errorGet = encodeURI(texto);
		return errorGet.length > 1840 ? errorGet.substr(0, 1840) + " Mas contenido..." : errorGet;
	}

}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/loader/oh.loader.ts